/**
 * California county geographic centroids — [lon, lat]. Used for the
 * county-level drill-down marker layer on the geographic map.
 *
 * Coordinates are interior centroids (Census Bureau-style) so they sit
 * on land rather than over water for coastal counties.
 *
 * Names are normalized to match `legacy_trust.normalize_county()` output
 * (no "County" suffix, title-cased).
 */

export const CA_COUNTY_CENTROIDS: Record<string, [number, number]> = {
  Alameda: [-121.913, 37.6017],
  Alpine: [-119.8815, 38.6024],
  Amador: [-120.6592, 38.4456],
  Butte: [-121.6005, 39.6646],
  Calaveras: [-120.5546, 38.2046],
  Colusa: [-122.2367, 39.1775],
  'Contra Costa': [-121.9018, 37.9197],
  'Del Norte': [-123.8979, 41.7367],
  'El Dorado': [-120.5239, 38.7796],
  Fresno: [-119.6489, 36.7547],
  Glenn: [-122.3917, 39.5985],
  Humboldt: [-123.7569, 40.6985],
  Imperial: [-115.3654, 33.0392],
  Inyo: [-117.4115, 36.5113],
  Kern: [-118.7335, 35.3433],
  Kings: [-119.8157, 36.0728],
  Lake: [-122.7541, 39.0834],
  Lassen: [-120.5946, 40.6738],
  'Los Angeles': [-118.2645, 34.3083],
  Madera: [-119.7474, 37.2118],
  Marin: [-122.7633, 38.0746],
  Mariposa: [-119.9061, 37.5739],
  Mendocino: [-123.4384, 39.4257],
  Merced: [-120.7178, 37.1942],
  Modoc: [-120.7178, 41.5887],
  Mono: [-118.8729, 37.9219],
  Monterey: [-121.2422, 36.2402],
  Napa: [-122.2654, 38.5025],
  Nevada: [-120.7677, 39.301],
  Orange: [-117.7626, 33.7175],
  Placer: [-120.7178, 39.0916],
  Plumas: [-120.8039, 40.0033],
  Riverside: [-115.9856, 33.7298],
  Sacramento: [-121.3447, 38.4747],
  'San Benito': [-121.0742, 36.5761],
  'San Bernardino': [-116.1781, 34.8414],
  'San Diego': [-116.7325, 33.0341],
  'San Francisco': [-122.4194, 37.7749],
  'San Joaquin': [-121.2725, 37.9356],
  'San Luis Obispo': [-120.4554, 35.3837],
  'San Mateo': [-122.3725, 37.4337],
  'Santa Barbara': [-120.0438, 34.5277],
  'Santa Clara': [-121.6552, 37.2333],
  'Santa Cruz': [-122.0083, 37.0455],
  Shasta: [-122.0407, 40.7559],
  Sierra: [-120.5234, 39.5816],
  Siskiyou: [-122.5266, 41.5921],
  Solano: [-121.9018, 38.2696],
  Sonoma: [-122.9886, 38.5278],
  Stanislaus: [-120.9968, 37.5519],
  Sutter: [-121.6936, 39.0345],
  Tehama: [-122.234, 40.1257],
  Trinity: [-123.1148, 40.6505],
  Tulare: [-118.7754, 36.2168],
  Tuolumne: [-119.9544, 38.0297],
  Ventura: [-119.0826, 34.4444],
  Yolo: [-121.9018, 38.6868],
  Yuba: [-121.4015, 39.2685],
};
